import generateVersionHash from '@utils/generateVersionHash';
import { createListMutations, createListState } from '@utils/storeHelpers';
import api from './constants';
import { postApi } from '@/lib/fetcher';

const bcko = {
  namespaced: true,
  state: createListState(),
  mutations: createListMutations(),
  actions: {
    async getData(ctx, { date, page, itemsPerPage, search }) {
      ctx.commit('clearData');
      ctx.commit('setLoading', true);
      const sortBy = 'id DESC';

      const cleanedSearch = {
        kode_wilayah: search.kode_wilayah || '',
        sandi_cabang: search.sandi_cabang || '',
        branch_code_bcko: search.branch_code_bcko || '',
        kode_cabang: search.kode_cabang || '',
        outlet_status: search.outlet_status || '',
        outlet_name: search.outlet_name || '',
        created_at: Array.isArray(search.created_at) && search.created_at.length === 2
          ? `${search.created_at[0]} to ${search.created_at[1]}`
          : (search.created_at || ''),
        updated_at: Array.isArray(search.updated_at) && search.updated_at.length === 2
          ? `${search.updated_at[0]} to ${search.updated_at[1]}`
          : (search.updated_at || ''),
      };

      const data = JSON.stringify({
        page: page.toString(),
        limit: itemsPerPage.toString(),
        search: cleanedSearch,
        sort_by: sortBy,
        version: generateVersionHash(
          itemsPerPage.toString() + page.toString(),
          date
        ),
      });

      const urlApi = api.GET_LIST_MASTER_BCKO;

      try {
        const responseData = await postApi(ctx, urlApi, data);

        if (responseData?.code === 200) {
          ctx.commit('setTotalData', { payload: responseData });
          ctx.commit('setData', { payload: responseData });
        }
      } catch (error) {
        // Handle error silently
      } finally {
        ctx.commit('setLoading', false);
      }
    },

    async createData(ctx, { date, formData }) {
      const data = JSON.stringify({
        kode_wilayah: formData.kode_wilayah,
        sandi_cabang: formData.sandi_cabang,
        branch_code_bcko: formData.branch_code_bcko,
        kode_cabang: formData.kode_cabang,
        outlet_status: formData.outlet_status,
        outlet_name: formData.outlet_name,
        version: generateVersionHash(
          formData.kode_wilayah + formData.sandi_cabang + formData.branch_code_bcko + formData.kode_cabang + formData.outlet_status + formData.outlet_name,
          date
        ),
      });

      const urlApi = api.CREATE_MASTER_BCKO;
      const responseData = await postApi(ctx, urlApi, data);

      return responseData;
    },

    async updateData(ctx, { date, formData }) {
      const data = JSON.stringify({
        id: formData.id,
        kode_wilayah: formData.kode_wilayah,
        sandi_cabang: formData.sandi_cabang,
        branch_code_bcko: formData.branch_code_bcko,
        kode_cabang: formData.kode_cabang,
        outlet_status: formData.outlet_status,
        outlet_name: formData.outlet_name,
        version: generateVersionHash(
          formData.id.toString() + formData.kode_wilayah + formData.sandi_cabang + formData.branch_code_bcko + formData.kode_cabang + formData.outlet_status + formData.outlet_name,
          date
        ),
      });

      const urlApi = api.UPDATE_MASTER_BCKO;
      const responseData = await postApi(ctx, urlApi, data);

      return responseData;
    },
  },
};

export default bcko;
